import React from 'react';
import { IconButton, Tooltip } from "@mui/material";
import { Brightness4, Brightness7 } from "@mui/icons-material";
import { useThemeContext } from '../../Themes/ThemeContext';

import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeIcon from '@mui/icons-material/DarkMode';

export default function DarkModeToggle() {

    const { theme, getCurrentTheme, updateTheme } = useThemeContext();
    const handleToggle = () => {
      updateTheme(theme === "light" ? "dark": "light")

    };


  return (
    <Tooltip title={`Switch to ${theme === "light" ? "dark" : "light"} mode`}>
      <IconButton onClick={handleToggle} color="inherit">
        {theme === "light" ? <LightModeIcon /> : <DarkModeIcon />}
      </IconButton>
    </Tooltip>
  );
}
